/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

export const translationData = {
  de: {
    addressWidget: {
      general: {
        loadingStatus: 'Adressen werden geladen …',
        savingStatus: 'Adresse wird gespeichert …',
      },
    },
    countryChangeWidget: {
      general: {
        loadingStatus: 'Land wird geladen …',
        savingStatus: 'Land wird geändert …',
      },
    },
    emailWidget: {
      general: {
        loadingStatus: 'E-Mail-Adressen werden geladen …',
        savingStatus: 'E-Mail-Adresse wird gespeichert …',
      },
    },
    birthdayWidget: {
      birthday: {
        title: 'Geburtstag',
      },
      button: {
        add: {
          label: 'Geburtsdatum hinzufügen',
        },
        cancel: {
          label: 'Abbrechen',
          aria: 'Geburtstag bearbeiten abbrechen',
        },
        delete: {
          label: 'Löschen',
          labelA11y: 'Geburtstag löschen',
        },
        edit: {
          label: 'Bearbeiten',
          labelA11y: 'Geburtstag bearbeiten',
        },
        save: {
          label: 'Speichern',
          aria: 'Geburtstag speichern',
        },
      },
      editBirthday: {
        headline: 'Geburtstag bearbeiten',
      },
      general: {
        loadingStatus: 'Geburtstag wird geladen …',
        savingStatus: 'Geburtstag wird gespeichert …',
      },
      input: {
        invalid: 'Das Datum ist im falschen Format, bitte geben Sie Ihr Geburtsdatum in einem gültigen Format ein.',
        label: 'Geburtsdatum',
        maxDate: 'Das Datum darf nicht in der Zukunft liegen.',
        minDate: 'Das Datum liegt zu weit in der Vergangenheit.',
        required: 'Kein Geburtsdatum angegeben',
      },
      noDate: {
        label: 'Kein Geburtsdatum angegeben',
      },
    },
    'BUTTON-RESEND-CODE-LB': 'Bestätigungscode erneut anfordern',
    completion: {
      loading: {
        status: 'Profil-Vollständigkeit wird geladen …',
      },
      progress: {
        label: 'Profil-Vollständigkeit',
        valueText: '{{PERCENT}}% des Profils sind vollständig',
      },
      success: {
        progress: {
          valueText: 'Profil vollständig',
        },
      },
    },
    'INPUT-PHONE-PIN-REQUEST-LB': 'Nummer verifizieren',
    nameWidget: {
      general: {
        loadingStatus: 'Name wird geladen …',
        savingStatus: 'Name wird gespeichert …',
      },
    },
    phoneWidget: {
      general: {
        loadingStatus: 'Mobilfunknummern werden geladen …',
        savingStatus: 'Mobilfunknummer wird gespeichert …',
      },
    },
    'PCCK-AUTH-60606':
      'Das Senden wurde temporär blockiert, da bereits mehrere SMS an diese Mobilfunknummer versendet wurden. Der Empfang der Nachricht kann je nach Land und Netzabdeckung einige Zeit in Anspruch nehmen. Wenn Sie dennoch keine Nachricht erhalten, versuchen Sie es bitte später noch einmal oder wenden Sie sich an den Porsche Connect Support.',
    'PCCK-PROFILE-62021':
      'Der eingegebene Bestätigungscode ist nicht korrekt. Bitte versuchen Sie es noch einmal oder fordern Sie einen neuen Bestätigungscode an.',
    'PCCK-TOOLTIP-0026':
      'Die hier angezeigte verifizierte Mobilfunknummer weist Sie als Inhaber dieses Accounts aus und verhindert den unbefugten Zugriff Dritter auf Ihre Daten und Dienste. Sie wird auch zur Freischaltung eines neuen Connect Fahrzeugs benötigt.',
    'PCCK-TOOLTIP-0029':
      'Sie benötigen mindestens eine verifizierte Mobilfunknummer. Diese weist Sie als rechtmäßigen Inhaber Ihres Accounts aus und verhindert den unbefugten Zugriff Dritter auf Ihre Daten und Dienste. Zudem wird sie u. a. für die Freischaltung Ihres Fahrzeugs für die Porsche Connect Dienste benötigt.',
    pidaw: {
      generic: {
        form: {
          requiredFields: {
            hint: 'Die mit * gekennzeichneten Felder sind Pflichtfelder.',
          },
        },
      },
    },
    pidp: {
      namewidget: {
        namechangemodal: {
          headline: {
            label: 'Sind Sie sicher, dass Sie Ihren Namen ändern möchten?',
          },
          text: {
            label:
              'Bitte stellen Sie sicher, dass Ihre Angaben korrekt sind, bevor Sie fortfahren. Wenn Sie Ihren Namen oder Ihre Adresse ändern, werden Ihre persönlichen Daten, einschließlich der Vertrags- und Rechnungsadressen, für alle mit Ihrem Konto verknüpften aktiven Verträge aktualisiert.',
          },
          checkbox: {
            label: 'Ich habe diese Informationen gelesen und verstanden. *',
          },
          submit: {
            button: 'Name ändern',
          },
          cancel: {
            button: 'Abbrechen',
          },
        },
      },
      changeCountry: {
        editBtn: {
          labelA11y: 'Land bearbeiten',
        },
        legalModal: {
          formAriaLabel: 'Länderwechsel bestätigen',
        },
        saving: {
          status: 'Land wird geändert …',
        },
        select: {
          cancelBtn: {
            labelA11y: 'Länderwechsel abbrechen',
          },
        },
      },
      editName: {
        initials: {
          label: 'Middle Initial',
        },
        input: {
          fathersName: {
            label: "Father's Name",
          },
          firstName: {
            label: 'Vorname',
          },
          initials: {
            label: 'Middle Initial',
          },
          lastName: {
            label: 'Nachname',
          },
          LastName2: {
            label: 'Zweiter Nachname',
          },
          localizedFirstname: {
            label: 'Vorname (phonetic)',
          },
          localizedLastname: {
            label: 'Nachname (phonetic)',
          },
          middleInitial: {
            label: 'Middle Initial',
          },
          middleName: {
            label: 'Zweiter Vorname',
          },
          secondName: {
            label: 'Zweiter Nachname',
          },
          suffix: {
            label: 'Suffix',
          },
        },
        select: {
          academicTitle: {
            label: 'Titel',
          },
          academicTitleNoneSelected: {
            label: 'Kein Titel',
          },
          gender: {
            label: 'Geschlecht',
          },
          salutation: {
            label: 'Anrede',
          },
        },
      },
      editPhone: {
        error: {
          verification: {
            pending: 'Für diese Mobilfunknummer wurde bereits eine SMS mit einem Bestätigungscode versendet.',
          },
        },
      },
      error: {
        backend: {
          message: 'Bei der Verarbeitung der Daten ist ein Fehler aufgetreten.',
        },
      },
      errorMessage: {
        invalidPostalCode: 'Bitte geben Sie Ihre Postleitzahl im korrekten Format ein.',
        invalidVatId: 'Bitte geben Sie eine gültige Umsatzsteuer-Identifikationsnummer ein.',
      },
      mobile: {
        verification: {
          description:
            'Sobald Sie Ihre Mobilfunknummer speichern, schicken wir Ihnen per SMS einen Verifizierungscode zu, um zu bestätigen, dass es sich tatsächlich um Ihre Nummer handelt.',
        },
      },
      paymentMethods: {
        page: {
          headingContext: ' – Verwalten Sie Ihre Zahlungsmethoden und sehen Sie Ihre Bestellungen ein.',
        },
      },
      personalData: {
        headline: 'Persönliche Daten',
        page: {
          loadingStatus: 'Persönliche Daten werden geladen …',
          loadedStatus: 'Persönliche Daten geladen.',
          headingContext: ' – Verwalten Sie Ihre persönlichen Daten.',
        },
        formErrors: {
          emailFormat: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        },
        emailAddresses: {
          loading: {
            status: 'E-Mail-Adressen werden geladen …',
          },
          error: {
            alreadyExists: 'Diese E-Mail-Adresse ist bereits vorhanden.',
          },
          saving: {
            status: 'E-Mail-Adresse wird gespeichert …',
          },
          edit: {
            buttonA11y: 'E-Mail-Adresse {{EMAIL_ADDRESS}} bearbeiten',
          },
          delete: {
            buttonA11y: 'E-Mail-Adresse {{EMAIL_ADDRESS}} löschen …',
          },
          editor: {
            formAriaLabel: 'E-Mail-Adresse bearbeiten',
          },
          save: {
            a11y: 'E-Mail-Adresse speichern',
          },
          cancel: {
            a11y: 'E-Mail-Adresse bearbeiten abbrechen',
          },
          cancelVerification: {
            a11y: 'E-Mail-Verifizierung abbrechen …',
          },
        },
        dealer: {
          edit: {
            button: {
              aria: 'Bevorzugtes Porsche Zentrum {{DEALER_NAME}} bearbeiten',
            },
          },
          save: {
            aria: 'Bevorzugtes Porsche Zentrum speichern',
          },
          cancel: {
            aria: 'Bearbeitung des Porsche Zentrums abbrechen',
          },
          loading: {
            status: 'Bevorzugtes Porsche Zentrum wird geladen …',
          },
          saving: {
            status: 'Bevorzugtes Porsche Zentrum wird gespeichert …',
          },
          editor: {
            formAria: 'Bevorzugtes Porsche Zentrum bearbeiten',
          },
        },
        preferredCommunicationChannel: {
          headline: 'Bevorzugter Kommunikationskanal',
          description: {
            label: 'Bitte wählen Sie aus, ob Sie zukünftig vorrangig per E-Mail oder per SMS kontaktiert werden möchten.',
          },
          email: {
            label: 'E-Mail',
            missing: 'Sie haben noch keine E-Mail-Adresse hinterlegt. Bitte fügen Sie eine bevorzugte E-Mail-Adresse hinzu.',
            unverified: 'Bitte verifizieren Sie Ihre bevorzugte E-Mail-Adresse, um diesen Kanal auswählen zu können.',
            groupAria: 'Bevorzugter Kommunikationskanal: E-Mail',
          },
          sms: {
            label: 'SMS',
            missing: 'Sie haben noch keine Mobilfunknummer hinterlegt. Bitte fügen Sie eine bevorzugte Mobilfunknummer hinzu.',
            unverified: 'Bitte verifizieren Sie Ihre bevorzugte Mobilfunknummer, um diesen Kanal auswählen zu können.',
            groupAria: 'Bevorzugter Kommunikationskanal: SMS',
          },
          loading: {
            status: 'Bevorzugter Kommunikationskanal wird geladen …',
          },
          error: {
            toast: 'Bevorzugter Kommunikationskanal konnte nicht gespeichert werden. Bitte versuchen Sie es später erneut.',
          },
        },
        preferredLanguage: {
          headline: 'Verfügbare Sprachen',
          cancel: {
            aria: 'Bearbeitung der bevorzugten Sprache abbrechen',
            button: 'Abbrechen',
          },
          edit: {
            button: 'Bearbeiten',
            buttonA11y: 'Bevorzugte Sprache bearbeiten',
          },
          info: {
            label: 'Bevorzugte Sprache',
          },
          instruction: {
            label: 'Wählen Sie Ihre bevorzugte Sprache aus der Liste aus.',
          },
          loading: {
            status: 'Bevorzugte Sprache wird geladen …',
          },
          save: {
            aria: 'Bevorzugte Sprache speichern',
            button: 'Speichern',
          },
          saving: {
            status: 'Bevorzugte Sprache wird gespeichert …',
          },
        },
        name: {
          cancel: {
            button: 'Abbrechen',
            aria: 'Name bearbeiten abbrechen',
          },
          description: {
            label:
              'Bitte teilen Sie eine etwaige Änderung Ihres Namens dem Porsche Connect Support oder Ihrem Porsche Zentrum mit. Anschließend wird Ihr Name in den Profildaten entsprechend aktualisiert.',
          },
          edit: {
            button: 'Bearbeiten',
            buttonA11y: 'Name bearbeiten',
          },
          form: {
            ariaLabel: 'Name bearbeiten',
          },
          headline: {
            label: 'Name',
          },
          nonEditableHint: {
            label:
              'Bitte teilen Sie Änderungen Ihres Names dem Porsche Connect Support oder Ihrem Porsche Zentrum mit. Anschließend wird Ihr Name entsprechend aktualisiert.',
          },
          save: {
            button: 'Speichern',
            aria: 'Name speichern',
          },
        },
      },
      secondaryUser: {
        headline: 'Nebenbenutzer',
        page: {
          loadingStatus: 'Nebenbenutzer werden geladen …',
          loadedStatus: 'Nebenbenutzer geladen.',
          headingContext: ' – Verwalten Sie die Nebenbenutzer Ihrer Fahrzeuge.',
        },
        activateSecondary: {
          btn: {
            labelA11y: 'Nebenbenutzer {{NAME}} aktivieren',
          },
        },
        addSecondary: {
          btn: {
            labelA11y:
              'Nebenbenutzer für Fahrzeug mit der Fahrgestellnummer {{VIN}} hinzufügen. Öffnet ein Formular zur Eingabe der Daten.',
          },
        },
        add: {
          continue: {
            button: {
              labelA11y: 'Nebenbenutzer hinzufügen',
            },
          },
          cancel: {
            button: {
              labelA11y: 'Hinzufügen des Nebenbenutzers abbrechen',
            },
          },
          success: {
            button: {
              labelA11y: 'Zur Übersicht der Nebenbenutzer zurückkehren',
            },
          },
        },
        activation: {
          continue: {
            button: {
              labelA11y: 'Nebenbenutzer aktivieren',
            },
          },
          cancel: {
            button: {
              labelA11y: 'Aktivierung des Nebenbenutzers abbrechen',
            },
          },
          vehicleLoginRequired: {
            button: {
              labelA11y: 'Aktivierung des Nebenbenutzers abschließen',
            },
          },
        },
        delete: {
          buttonA11y: 'Nebenbenutzer {{NAME}} löschen …',
        },
      },
      verifyMobile: {
        blockedFor30Minutes:
          'Aus Sicherheitsgründen ist das Senden eines neuen Bestätigungscodes für 30 Minuten gesperrt. Bitte versuchen Sie es später erneut.',
        tooManyInvalidTrials:
          'Leider wurden mehrfach fehlerhafte SMS PINs eingegeben. Aus Sicherheitsgründen ist daher die Verifizierung temporär blockiert. Bitte wenden Sie sich bei Fragen an den Porsche Connect Support.',
      },
    },
    pidpaw: {
      deleteAddress: {
        button: {
          ok: 'OK',
        },
        error: {
          deleteLast: 'Diese Adresse kann nicht gelöscht werden. Es muss mindestens eine Adresse in Ihrem Profil hinterlegt sein.',
        },
      },
      deletePhone: {
        button: {
          ok: 'OK',
        },
        error: {
          deleteLast:
            'Diese Mobilfunknummer kann nicht gelöscht werden. Es muss mindestens eine Mobilfunknummer in ihrem Profil hinterlegt sein.',
        },
      },
      editAddress: {
        backendError: {
          maxLength: 'Das Maximum für dieses Feld beträgt {{maxLength}} Zeichen.',
        },
        button: {
          add: {
            label: 'Hinzufügen',
          },
          cancel: {
            aria: 'Adresse bearbeiten abbrechen',
            label: 'Abbrechen',
          },
          delete: {
            aria: 'Adresse löschen:',
            label: 'Löschen',
            labelA11y: 'Adresse {{ADDRESS}} löschen',
          },
          deleteAddress: {
            label: 'Adresse löschen',
          },
          save: {
            aria: 'Adresse speichern',
            label: 'Speichern',
          },
          saveAndContinue: {
            aria: 'Adresse speichern und weiter',
            label: 'Speichern und weiter',
          },
        },
        checkbox: {
          defaultAddress: {
            label: 'Dies ist meine bevorzugte Adresse, über die ich kontaktiert werden möchte.',
          },
        },
        deleteConfirmationModal: {
          btnGhost: 'Abbrechen',
          btnPrimary: 'Löschen',
          title: 'Möchten Sie diese Adresse wirklich löschen?',
        },
        error: {
          backend: {
            add: 'Beim Hinzufügen der Telefonnummer ist ein Fehler aufgetreten.',
            default: 'Ein unerwarteter Fehler ist aufgetreten.',
            delete: 'Beim Löschen der Telefonnummer ist ein Fehler aufgetreten.',
            edit: 'Beim Bearbeiten der Telefonnummer ist ein Fehler aufgetreten.',
          },
          inputRequired: 'Dieses Feld ist ein Pflichtfeld.',
        },
        headline: {
          additionalAddresses: 'Weitere Adressen',
          addNewAddress: 'Neue Adresse hinzufügen',
          addresses: 'Adressen',
          editAddress: 'Adresse bearbeiten',
          primaryAddress: 'Bevorzugte Adresse',
        },
        input: {
          address: {
            label: 'Beginnen Sie mit Ihrer Adresse...',
            placeholder: ' ',
            initialLoading: 'Bitte geben Sie mindestens vier Zeichen ein, um die Adresssuche zu starten.',
            loading: 'Adressvorschläge werden geladen.',
            emptyResult: 'Keine passenden Adressen gefunden.',
          },
          archivedCompanyCareOf: {
            label: 'c/o',
          },
          buildingCode: {
            label: 'Gebäudenummer',
          },
          city: {
            label: 'Stadt',
          },
          companyCareOf: {
            label: 'Adresszusatz (Zustellhinweis, c/o, etc.)',
          },
          companyName: {
            label: 'Firma',
          },
          country: {
            label: 'Land',
            placeholder: 'Land auswählen',
          },
          district: {
            label: 'Bezirk',
          },
          floor: {
            label: 'Flur',
          },
          houseNo: {
            label: 'Hausnummer',
          },
          poBox: {
            label: 'Postfach',
          },
          poBoxZipcode: {
            label: 'Postfach Postleitzahl',
          },
          region: {
            label: 'Region',
            placeholder: 'Region auswählen',
          },
          roomNumber: {
            label: 'Raum',
          },
          street: {
            label: 'Straße',
          },
          street2: {
            label: 'Straße 2',
          },
          street3: {
            label: 'Straße 3',
          },
          supplement: {
            label: 'Addresszusatz',
          },
          vatId: {
            label: 'Umsatzsteuer-Identifikationsnummer',
          },
          zipcode: {
            label: 'Postleitzahl',
          },
        },
        radio: {
          addressTypeHome: {
            label: 'Privat',
          },
          addressTypeWork: {
            label: 'Geschäftlich',
          },
        },
      },
      editName: {
        error: {
          inputRequired: 'Dieses Feld ist ein Pflichtfeld.',
        },
      },
      editPhone: {
        form: {
          aria: 'Telefonnummer bearbeiten',
        },
        button: {
          add: {
            label: 'Hinzufügen',
          },
          cancel: {
            label: 'Abbrechen',
            aria: 'Telefonnummer bearbeiten abbrechen',
          },
          delete: {
            label: 'Telefonnummer löschen',
          },
          save: {
            label: 'Speichern',
            aria: 'Telefonnummer speichern',
          },
          saveAndContinue: {
            label: 'Speichern und weiter',
            aria: 'Telefonnummer speichern und weiter',
          },
          saveAndVerify: {
            label: 'Speichern und Verifizieren',
            aria: 'Telefonnummer speichern und verifizieren',
          },
          verify: {
            cancel: {
              label: 'Abbrechen',
            },
            ok: {
              label: 'Bestätigungscode anfordern',
            },
          },
        },
        checkbox: {
          defaultPhone: {
            label: 'Dies ist meine bevorzugte Telefonnummer, über die ich kontaktiert werden möchte.',
          },
        },
        deleteConfirmationModal: {
          btnGhost: 'Abbrechen',
          btnPrimary: 'Löschen',
          title: 'Möchten Sie diese Telefonnummer wirklich löschen?',
        },
        error: {
          countryPrefix: 'Bitte geben Sie eine korrekte Ländervorwahl ein',
          duplicate: 'Die eingegebene Nummer ist bereits vorhanden.',
          inputRequired: 'Dieses Feld ist ein Pflichtfeld',
          phoneInput: 'Die eingegebene Telefonnummer ist nicht korrekt.',
          verification: {
            expiredCode: 'Der eingegebene Bestätigungscode ist nicht mehr gültig. Bitte fordern Sie einen neuen Bestätigungscode an.',
            wrongCode: 'Der eingegebene Bestätigungscode ist nicht korrekt. Bitte versuchen Sie es erneut.',
          },
        },
        headline: {
          addNewPhone: 'Neue Telefonnummer hinzufügen',
          editPhone: 'Telefonnummer bearbeiten',
          verification: {
            requestAndInsert: 'Bestätigungscode  anfordern und eingeben',
          },
        },
        verification: {
          pinCode: {
            label: 'Bestätigungscode',
          },
        },
        icon: {
          phoneTypeLandline: {
            label: 'Festnetz',
          },
          phoneTypeMobile: {
            label: 'Mobil',
          },
        },
        input: {
          country: {
            label: 'Land',
            placeholder: 'Land auswählen',
          },
          phone: {
            label: 'Telefonnummer',
            placeholder: 'Telefonnummer eintragen',
          },
        },
        label: {
          tooManyPhones: 'Sie müssen eine Ihrer aktuellen Telefonnummern löschen, bevor Sie eine neue hinzufügen können.',
          verification: {
            noSMSReceived: 'Sie haben keine SMS erhalten?',
            requestCodeAgain: 'Code erneut anfordern',
          },
        },
        radio: {
          addNumber: {
            label: 'Telefonnummer hinzufügen',
          },
          phoneType: {
            groupAria: 'Art der Telefonnummer',
          },
          phoneTypeLandline: {
            label: 'Festnetznummer',
          },
          phoneTypeMobile: {
            label: 'Mobilfunknummer',
          },
        },
        text: {
          verification: {
            insertCode: 'Geben Sie den 5-stelligen Code ein, den Sie per SMS an folgende Nummer erhalten haben:',
            modal: 'Hiermit stimmen Sie zu, dass Sie von Porsche eine Textnachricht erhalten.',
            success: 'Die Mobilfunknummer wurde erfolgreich verifiziert und gespeichert. ',
            waitingTimerMessage: 'Sie können in ({{TIME_REMAINING}}) einen neuen Code anfordern.',
          },
        },
        tooltip: {
          verification: {
            info: 'Je nach Netzauslastung kann es eine gewisse Zeit dauern, bis der Code bei Ihnen ankommt. Sollten Sie auch nach mehreren Minuten keinen Code empfangen, prüfen Sie bitte, ob die von Ihnen eingegebene Mobilfunknummer korrekt ist und stellen Sie sicher, dass Sie eine gute Netzwerkverbindung haben. Klicken Sie anschließend auf „Bestätigungscode erneut senden“. Sollten Sie weiterhin keinen Code empfangen, wenden Sie sich bitte an den Porsche Connect Support.',
          },
        },
      },
      editPhones: {
        headline: {
          additionalPhones: 'Weitere Telefonnummern',
          phones: 'Telefonnummern',
          primaryMobile: 'Bevorzugte Telefonnummer',
        },
      },
      generic: {
        aria: {
          loading: 'Wird geladen',
        },
        button: {
          addAddress: {
            label: 'Adresse hinzufügen',
          },
          addPhone: {
            label: 'Telefonnummer hinzufügen',
          },
          delete: {
            label: 'Löschen',
          },
          edit: {
            label: 'Bearbeiten',
          },
        },
        error: {
          backend: {
            default: 'Ein unerwarteter Fehler ist aufgetreten.',
          },
          initialisation:
            'Beim Laden Ihrer Daten ist ein Fehler aufgetreten. Bitte laden Sie die Seite erneut oder versuchen Sie es zu einem späteren Zeitpunkt noch einmal.',
        },
        headline: {
          selectOrAddAddress: 'Adresse wählen oder hinzufügen',
          selectOrAddPhone: 'Telefonnummer wählen oder hinzufügen',
        },
        label: {
          tooManyAddresses: 'Sie müssen eine Ihrer aktuellen Adressen löschen, bevor Sie eine neue hinzufügen können.',
        },
        noEntries: {
          label: 'Keine Einträge',
        },
      },
      phone: {
        text: {
          preferred: 'Bevorzugte Telefonnummer',
        },
      },
      selectAddress: {
        address: {
          preferredMarker: 'Bevorzugt',
        },
        button: {
          editAddress: {
            aria: 'Adresse bearbeiten:',
            label: 'Bearbeiten',
            labelA11y: 'Adresse {{ADDRESS}} bearbeiten',
          },
          emptyState: {
            label: 'Sie haben keine Adressen hinterlegt',
          },
        },
        list: {
          aria: {
            additional: 'Liste der weiteren Adressen',
            all: 'Liste der Adressen',
            checkout: 'Lieferadresse auswählen',
            mylanta: 'Adressen',
            primary: 'Bevorzugte Adresse',
          },
        },
        text: {
          preferredAddress: 'Bevorzugte Adresse',
        },
      },
      selectPhone: {
        list: {
          aria: {
            checkout: 'Telefonnummer auswählen',
          },
        },
        button: {
          changePorscheId: {
            aria: 'Porsche ID ändern',
          },
          deletePhone: {
            labelA11y: 'Telefonnummer {{PHONE_NUMBER}} löschen',
          },
          editPhone: {
            label: 'Bearbeiten',
            labelA11y: 'Telefonnummer {{PHONE_NUMBER}} bearbeiten',
          },
          emptyState: {
            label: 'Sie haben keine Telefonnummern hinterlegt',
          },
        },
        icon: {
          phoneUnverified: {
            label: 'nicht verifiziert',
          },
        },
        text: {
          preferredPhone: 'Dies ist meine bevorzugte Telefonnummer, über die ich kontaktiert werden möchte.',
        },
      },
    },
    'PROFILE-TAB-PAYMENT': 'Zahlungsmethoden',
    'WIDGETS-ADDRESS-TELEPHONE-INPUT-PIN-LB': 'Code hier eingeben',
    'WIDGETS-ADDRESS-TELEPHONE-INPUT-PIN-PH': 'Code hier eingeben',
    'WIDGETS-ADDRESS-TELEPHONE-INPUT-PIN-REQUIRED-LB': 'Code hier eingeben*',
    'WIDGETS-ADDRESS-TELEPHONE-INPUT-PIN-REQUIRED-PH': 'Code hier eingeben*',
  },
}
